import { z } from 'zod';
import { sizeSchema, coordinateSchema, fontSizeSchema } from '../../../Shared.js';
import { numberSchema } from '../schemas.js';

const textItemSchema = z.object({
  kind: z.literal("text"),
  id: z.string(),
  position: coordinateSchema,
  size: sizeSchema,
  htmlContent: z.string(),
  settings: z.object({
    hideDragHandle: z.boolean().optional(),
    movable: z.boolean().default(false),
    cloneable: z.boolean().default(false)
  }).nullish().default({}),
  style: z.object({
    verticallyCenterContent: z.boolean().default(false),
    mockDefaultBrowserPadding: z.boolean().optional(),
    background: z.object({
      color: z.string(),
      opacity: z.number().optional()
    }),
    border: z.object({
      style: z.string(),
      width: numberSchema(1),
      color: z.string(),
      radius: z.number().optional()
    }).optional(),
    font: z.object({
      size: z.union([z.number(), fontSizeSchema]),
      family: z.string().optional(),
      color: z.string().optional()
    })
  }).nullish().default({ background: { color: "#fff" }, font: { size: "medium" } })
});

export { textItemSchema };
//# sourceMappingURL=Text.js.map
